@use '../../../common/styles/variables' as *;
@use '../../../common/mixins/inputs' as *;

:host {
  display: block;
  height: auto;
  @include default-css-variables;
  width: 100%;
}

.nylas-event-title {
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: relative;
  text-align: left;
  color: var(--nylas-base-900);

  div.title {
    // Apply textfield styles but override display and alignment for contentEditable
    border-radius: var(--nylas-border-radius-2x);
    border: 1px solid var(--nylas-base-300);
    background: var(--nylas-base-0);
    width: -webkit-fill-available;
    height: 48px;
    padding: 12px 16px;
    overflow: auto;
    white-space: nowrap;
    scrollbar-width: thin;
    color: var(--nylas-base-900);
    font-family: var(--nylas-font-family);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    -webkit-text-fill-color: var(--nylas-base-900);
    display: block;

    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    &:focus {
      color: var(--nylas-base-900);
      -webkit-text-fill-color: var(--nylas-base-900);
      outline: 2px solid var(--nylas-primary);
      outline-offset: 2px;
    }

    &:focus-visible {
      color: var(--nylas-base-900);
      -webkit-text-fill-color: var(--nylas-base-900);
      outline: 2px solid var(--nylas-primary);
      outline-offset: 2px;
    }

    &.error {
      border-color: var(--nylas-error);
      border-width: 2px;
    }
  }

  input {
    padding: 12px 16px;
    border-width: 1;
    border-radius: 8px;
    border: 1px solid var(--nylas-base-200);
  }

  span.help-text {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: var(--nylas-base-500);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
    position: relative;

    span.label-icon {
      display: inline-flex;
      align-items: center;
      flex-shrink: 0;

      tooltip-component {
        display: flex;
        &::part(tc__container) {
          position: unset;
        }

        &::part(tc__content) {
          position: absolute;
          top: 4px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }

  span.error-message {
    color: var(--nylas-error);
  }

  label {
    @include input-label;
    flex-direction: column;
    gap: 4px;
    font-family: var(--nylas-font-family);
    align-items: flex-start;

    p {
      margin: 0;
      display: flex;
      align-items: center;
    }

    span.required {
      color: var(--nylas-error, #cc4841);
    }

    span.label-icon {
      margin-left: 4px;

      tooltip-component {
        display: flex;
      }
    }
  }
}

.highlighted-tag {
  background-color: var(--nylas-base-200);
  border-radius: var(--nylas-border-radius);
  padding: 5px;
  margin-left: 4px;
}

.token-options {
  display: block;
  background-color: var(--nylas-base-0);
  width: 100%;
  max-height: 336px;
  overflow: auto;
  z-index: 1;
  border-radius: 4px;
  position: absolute;
  top: calc(48px + 24px + 8px); // 48px is the height of the input, 24px is the height of the label, 8px is the gap between the label and the input

  box-shadow: 0px 4px 6px -2px #0000000d;
  box-shadow: 0px 10px 15px -3px #0000001a;

  @media #{$mobile} {
    right: 0;
    width: 325px;
    max-width: unset;
  }

  ul {
    padding: 0;
    list-style-type: none;
    color: var(--nylas-base-900);
    max-height: 336px;
    margin: 0;

    li {
      padding: 16px, 12px, 16px, 12px;
      color: var(--nylas-base-900);
      padding: 12px 16px;
      text-decoration: none;
      display: block;
      font-family: inherit;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0px;
      text-align: left;
      cursor: pointer;

      .token-label {
        display: flex;
        flex-direction: column;
        font-weight: 400;

        .token {
          color: var(--nylas-abse-900);
          font-size: 16px;
          line-height: 24px;
        }

        .description {
          color: var(--nylas-base-600);
          font-size: 14px;
          line-height: 21px;
        }
      }

      &:hover,
      &:focus,
      &:active,
      &.active {
        background-color: var(--nylas-base-100);

        .token-label {
          .token {
            color: var(--nylas-primary);
          }
        }
      }
    }
  }

  .selected {
    background-color: var(--nylas-base-100);
  }
}
